import { render, staticRenderFns } from "./CategoryChips.vue?vue&type=template&id=42e27c5a&scoped=true"
import script from "./CategoryChips.vue?vue&type=script&lang=js"
export * from "./CategoryChips.vue?vue&type=script&lang=js"
import style0 from "./CategoryChips.vue?vue&type=style&index=0&id=42e27c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e27c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e27c5a')) {
      api.createRecord('42e27c5a', component.options)
    } else {
      api.reload('42e27c5a', component.options)
    }
    module.hot.accept("./CategoryChips.vue?vue&type=template&id=42e27c5a&scoped=true", function () {
      api.rerender('42e27c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/member/cashier/CategoryChips.vue"
export default component.exports